import React, { useState } from 'react';
import {
  useDisclosure,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  useColorModeValue,
  Icon,
  Divider,
  Box,
  AbsoluteCenter,
  Text,
  Flex,
  Image
} from '@chakra-ui/react';
import { MdEditDocument } from 'react-icons/md';
import { MdCancel, MdCheckCircle, MdOutlineError } from 'react-icons/md';
import ChecklistService from '../../../../../services/ChecklistService';

export default function AlertDialogExample(props) {

  const [vehicle, setVehicle] = useState("")
  const [driver, setDriver] = useState("")
  const [precheckRecord, setPrecheckRecord] = useState("")
  const [imageMap, setImageM] = useState(new Map())

  const token = localStorage.getItem('token');
  const loadData = async (e) => {
    e.preventDefault();
    onOpen();
    setSelectedChecklistDetails(e.currentTarget.parentElement.id);


  };
  const textColor = useColorModeValue('secondaryGray.900', 'white');



  const setSelectedChecklistDetails = async (id) => {
    try {
      const response = await ChecklistService.getPrechecklistRecord(token, id);
      const vehicle = {
        vinNumber: response.data.object.vehicle.vinNumber,
        make: response.data.object.vehicle.make,
        model: response.data.object.vehicle.model,
        vehicleCategory: response.data.object.vehicle.vehicleCategory.category,
        vehicleType: response.data.object.vehicle.vehicleType.type,
        rego: response.data.object.vehicle.registration,
        year: response.data.object.vehicle.year
      };
      const driver = {
        name: response.data.object.user.preferredName,
        email: response.data.object.user.emailAddress,
        mobile: response.data.object.user.mobileNumber
      };

      let status = '';

      if (response.data.object.statusMap['Do Not Operate Machinery']) {
        status = 'Do Not Operate Machinery';
      } else if (response.data.object.statusMap['Report & Proceed with Caution']) {
        status = 'Report & Proceed with Caution';
      } else if (response.data.object.statusMap['Success']) {
        status = 'Success';
      }

      const precheckRecord = {
        status: status,
        recordList: response.data.object.preStartCheckDtoRecord
      };
      setVehicle(vehicle)
      setDriver(driver)
      setPrecheckRecord(precheckRecord)

    } catch (error) {
      console.log(error);
    }
  };

  const getImage = async (index, id) => {
    let returnedData = '';
    try {
      const response = await ChecklistService.getImage(
        token,
        id,
      );
      if (response.data && response.status === 201) {
        returnedData = response.data.object.stringImageBase64;

      }
      const newMap = new Map(imageMap);
      newMap.set(index, returnedData);
      setImageM(newMap)
    } catch (error) {
      console.log(error);
    }
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const iconColor = useColorModeValue('brand.500', 'white');

  return (
    <>
      <Button onClick={(e) => (loadData(e))}>
        <Icon
          as={MdEditDocument}
          color={iconColor}
          w="24px"
          h="24px"
        />
      </Button>

      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size='xl'
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Precheck Checklist Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={10}>
            <Box position='relative' padding='4'>
              <Divider />
              <AbsoluteCenter bg='white' px='4'>
                Vehicle Details
              </AbsoluteCenter>
            </Box>
            <FormControl>
              <FormLabel><Text as='b'>Rego</Text> : {vehicle.rego}</FormLabel>
              <FormLabel><Text as='b'>Vin Number</Text> : {vehicle.vinNumber}</FormLabel>
              <FormLabel><Text as='b'>Make</Text> : {vehicle.make}</FormLabel>
              <FormLabel><Text as='b'>Model</Text> : {vehicle.model}</FormLabel>
              <FormLabel><Text as='b'>Year</Text> : {vehicle.year}</FormLabel>
              <FormLabel><Text as='b'>Category</Text>  : {vehicle.vehicleCategory}</FormLabel>
              <FormLabel><Text as='b'>Type</Text> : {vehicle.vehicleType}</FormLabel>
            </FormControl>

            <Box position='relative' padding='4'>
              <Divider />
              <AbsoluteCenter bg='white' px='4'>
                Driver Details
              </AbsoluteCenter>
            </Box>
            <FormControl>
              <FormLabel><Text as='b'>Driver</Text> : {driver.name}</FormLabel>
              <FormLabel><Text as='b'>Email</Text> : {driver.email}</FormLabel>
              <FormLabel><Text as='b'>Mobile</Text> : {driver.mobile}</FormLabel>
            </FormControl>

            <Box position='relative' padding='8'>
              <Divider />
              <AbsoluteCenter bg='white' px='1'>
                Pre Check Details
              </AbsoluteCenter>
            </Box>
            <FormControl>
              <FormLabel>
                <Flex align="center">
                  <Text as='b'>Status : </Text>
                  <Icon
                    w="24px"
                    h="24px"
                    me="5px"
                    color={
                      precheckRecord.status === 'Success'
                        ? 'green.500'
                        : precheckRecord.status === 'Do Not Operate Machinery'
                          ? 'red.500'
                          : precheckRecord.status === 'Report & Proceed with Caution'
                            ? 'orange.500'
                            : null
                    }
                    as={
                      precheckRecord.status === 'Success'
                        ? MdCheckCircle
                        : precheckRecord.status === 'Do Not Operate Machinery'
                          ? MdCancel
                          : precheckRecord.status === 'Report & Proceed with Caution'
                            ? MdOutlineError
                            : null
                    }
                  />
                  <Text color={textColor} fontSize="sm" fontWeight="700">
                    {precheckRecord.status}
                  </Text>
                </Flex></FormLabel>

              <Box position='relative' padding='8'>
                <Divider />
                <AbsoluteCenter bg='white' px='1'>
                  Precheck Records Details
                </AbsoluteCenter>
              </Box>

              {precheckRecord.recordList && precheckRecord.recordList.map((record, mainIndex) => (
                <FormControl>
                  <FormControl mt={4}>
                  <FormLabel><Text as='b'>Item Section</Text> : {record.preStartItem.preStartItemSection.section}</FormLabel>
                  <FormLabel><Text as='b'>Item Id</Text> : {mainIndex + 1}</FormLabel>
                  <FormLabel><Text as='b'>Item</Text> : {record.preStartItem.item}</FormLabel>
                  <FormLabel><Flex align="center"><Text as='b'>Item Status : </Text><Text color={
                    record.status === true
                      ? 'green.500'
                      : record.status !== true & record.preStartItem.preStartItemLevel.level === 'Do Not Operate Machinery'
                        ? 'red.500'
                        : record.status !== true & record.preStartItem.preStartItemLevel.level === 'Report & Proceed with Caution'
                          ? 'orange.500'
                          : null
                  }> {record.status === true ? 'Success' : record.preStartItem.preStartItemLevel.level}</Text></Flex>
                  </FormLabel>
                  </FormControl>
                  <FormControl mt={4}>
                  {record.preStartCheckRecordAttachment.length !== 0 && (
                    <>
                      <FormLabel><Text as='b'>Description : </Text> {record.description}</FormLabel>
                      <FormLabel><Text>Attachment : </Text>

                        {record.preStartCheckRecordAttachment.map((item, index) => (
                          <Box boxSize='150px' objectFit='cover'>
                            <Image boxSize='150px' objectFit='cover' onClick={(g) => getImage(mainIndex + index, item.attachment)} src={imageMap.get(mainIndex + index)} alt={record.description} />
                          </Box>
                        ))}

                      </FormLabel>
                    </>
                  )}
                  <Divider />
                  </FormControl>
                </FormControl>

              ))}
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} >
              Generate Report
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
